import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@store/index';
import { selectTheme } from '@features/ui/uiSlice';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** The server renders an XLSX preview in a language and theme; every other type takes neither. */
export function useDocumentPreviewOptions(
  doc: { metadata?: { fileName?: string; mimeType?: string } } | null,
): { language?: 'ja' | 'en'; theme?: 'light' | 'dark' } {
  const { i18n } = useTranslation();
  const theme = useAppSelector(selectTheme);
  const isXlsx = doc?.metadata?.fileName?.toLowerCase().endsWith('.xlsx') || doc?.metadata?.mimeType === XLSX_MIME;
  return isXlsx ? { language: i18n.language?.startsWith('en') ? 'en' : 'ja', theme } : {};
}
